import React from 'react'
import { Typography } from '@mui/material'

import { Button, Modal } from '@repo/ui'

import { OutreachCertificatePanel } from './OutreachCertificatePanel'

/** VRG-723 — the outreach certificate panel, opened from a Demos row. */
export const OutreachCertificateModal = ({
  companyId,
  companyName,
  onClose,
}: {
  companyId: string | null
  companyName?: string
  onClose: () => void
}) => (
  <Modal
    title="Outreach certificate"
    titleAdornment={
      companyName ? (
        <Typography variant="body3" color="text.secondary">
          {companyName}
        </Typography>
      ) : undefined
    }
    open={!!companyId}
    onClose={onClose}
    actions={<Button onClick={onClose}>Done</Button>}
  >
    {companyId && <OutreachCertificatePanel companyId={companyId} />}
  </Modal>
)
